export const API_URL_PROD = 'https://timetablesapi.sobm.bcit.ca/portal';
export const API_URL_TEST = 'https://timetablesapitest.sobm.bcit.ca/portal';
export const EXP_URL_PROD = 'https://timetablesportalexp.sobm.bcit.ca/api'
export const EXP_URL_TEST = 'https://timetablesportalexptest.sobm.bcit.ca/api'

export const accountTypes = {
    superAdmin: 'superadmin',
    admin: 'academicadmin',
    timetabler: 'schooltimetabler',
    facilities: 'facilities',
    instructor: 'instructor',
    reader: 'reader',
    centralTimetabler: 'centraltimetabler',
};

export const viewTypeArr = [
    {
        label: 'Facilities',
        type: 'facilities-view',
    },
    {
        label: 'Academic',
        type: 'academic-view',
    },
    {
        label: 'Central Timetabler',
        type: 'central-timetabler-view',
    }
];

export const FACILITIES_VIEW_TYPE = 'facilities-view';
export const ACADEMIC_VIEW_TYPE = 'academic-view';
export const CENTRAL_TIMETABLER_VIEW_TYPE = 'central-timetabler-view';

export const localStorageKey = 'tt-portal-current-user';
export const viewTypeStorageKey = 'current-user-viewType';

export const courseTimeArr = [
    {
        label: 'Daytime',
        shortLabel: 'Day',
        value: 'day',
    },
    {
        label: 'Night-time',
        shortLabel: 'Night',
        value: 'night',
    },
];

export const defaultFilerOptionsArr = [
    { id: 1, label: 'All', value: 'all' },
    { id: 2, label: 'On', value: true },
    { id: 3, label: 'Off', value: false },
];

export const isActiveFilterOptionsArr = [
    { id: 1, label: 'All', value: 'all' },
    { id: 2, label: 'Active', value: true },
    { id: 3, label: 'Inactive', value: false },
];

export const defaultDropdownArr = [
    { id: 1, label: 'Yes', value: true },
    { id: 2, label: 'No', value: false },
];

export const TERM_PLANNER_CANCELLED_STATUS_ID = 4;
export const INSTRUCTOR_TIMETABLE = 'INSTRUCTOR_TIMETABLE';
export const SET_TIMETABLE = 'SET_TIMETABLE';
export const ROOM_TIMETABLE = 'ROOM_TIMETABLE';
export const NEXT_WEEK = 'Next Week';
export const PREV_WEEK = 'Prev Week';
export const BUSINESS_SCHOOL_ID = 1;
export const KENDO_TIME_PICKER_FORMAT = 'MMM-dd-yyyy';
//FIXME: remove the hard-coded name and fetch from db instead
export const BURNABY_CAMPUS_NAME = 'Burnaby';
export const DTC_CAMPUS_ID = 2;
